import styled from 'styled-components';
import { styledByTheme } from '../../../themes/architecture/styled-by-theme';

export const GameItemJackpotDefaultBox = styled.div`
    width: 15rem;
    margin: 5px 0;
    font-size: 1.5rem;
    ${({theme}) => theme.font.presets.bold};
    color: ${({theme}) => theme.colors.brandSecondary};
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 1.3rem;
    }
`;

export const GameItemJackpotSICisBox = styled(GameItemJackpotDefaultBox)`
    width: 75%;
`;



export const GameItemJackpotBox = styledByTheme(GameItemJackpotDefaultBox).forSICis(GameItemJackpotSICisBox).apply();
